import type { ChangeEvent } from "react";
import { useMemo } from "react";
import { debounce } from "lodash";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { isValidURL } from "@/react/helpers/urlHelpers/isValidUrl";
import { Form } from "@circle-react-uikit/Form";

export interface UrlFieldProps {
  label: string;
  name: string;
}

export const UrlField = ({ name, label }: UrlFieldProps) => {
  const { setError } = useFormContext();

  const debouncedValidateUrl = useMemo(
    () =>
      debounce((url: string) => {
        if (isValidURL(url)) {
          return;
        }
        setError(name, {
          type: "manual",
          message: t("builder_ui.prop_type.errors.invalid_url"),
        });
      }, 1000),
    [name, setError],
  );

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const url = event.target.value;
    debouncedValidateUrl(url);
  };

  return (
    <Form.Item
      name={name}
      label={label}
      hideDescription
      hideBorder
      className="!p-0"
      placeholder={t("builder_ui.prop_type.url_placeholder")}
    >
      <Form.Input type="url" name={name} onChange={onChangeHandler} />
    </Form.Item>
  );
};
